import { render, staticRenderFns } from "./finish-approval-list.vue?vue&type=template&id=133f6d7e"
import script from "./finish-approval-list.vue?vue&type=script&lang=js"
export * from "./finish-approval-list.vue?vue&type=script&lang=js"
import style0 from "./finish-approval-list.vue?vue&type=style&index=0&id=133f6d7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports